import { render } from "./app-icon.vue?vue&type=template&id=ee4ec148"
import script from "./app-icon.vue?vue&type=script&lang=js"
export * from "./app-icon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/icon/app-icon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ee4ec148"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ee4ec148', __exports__)) {
    console.log('reload')
    api.reload('ee4ec148', __exports__)
  }
  
  module.hot.accept("./app-icon.vue?vue&type=template&id=ee4ec148", () => {
    console.log('re-render')
    api.rerender('ee4ec148', render)
  })

}


export default __exports__